import type { Address } from '@/modules/address/domain/Address';
import useCommunes from '@/sections/region/hooks/useCommunes';
import useRegions from '@/sections/region/hooks/useRegions';

const useLabeledAddress = (address?: Address | null): string | undefined => {
  const { data: regions } = useRegions();
  const { data: communes } = useCommunes(Number(address?.region) as number);

  if (!address) return undefined;

  const regionSelected = regions?.find(({ id }) => address?.region == id);
  const communeSelected = communes?.find(
    ({ code }) => address?.commune == code
  );

  const { streetName, streetNumber, apartment, additionalStreetInfo } = address;

  return [
    streetName,
    streetNumber,
    additionalStreetInfo || apartment,
    communeSelected?.name,
    regionSelected?.name
  ]
    .filter(Boolean)
    .join(', ');
};

export default useLabeledAddress;
